/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Removed_ToastInputs */

const en_style_guide_manager_removed_toast = /** @type {(inputs: Style_Guide_Manager_Removed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style guide removed successfully`)
};

const fr_style_guide_manager_removed_toast = /** @type {(inputs: Style_Guide_Manager_Removed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide de style supprime avec succes`)
};

const de_style_guide_manager_removed_toast = /** @type {(inputs: Style_Guide_Manager_Removed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Styleguide erfolgreich entfernt`)
};

const it_style_guide_manager_removed_toast = /** @type {(inputs: Style_Guide_Manager_Removed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guida di stile rimossa con successo`)
};

const ru_style_guide_manager_removed_toast = /** @type {(inputs: Style_Guide_Manager_Removed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стиль оформления успешно удален.`)
};

const es_style_guide_manager_removed_toast = /** @type {(inputs: Style_Guide_Manager_Removed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guía de estilo eliminada con éxito`)
};

const zh_cn2_style_guide_manager_removed_toast = /** @type {(inputs: Style_Guide_Manager_Removed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`样式指南已成功移除`)
};

const ja_style_guide_manager_removed_toast = /** @type {(inputs: Style_Guide_Manager_Removed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタイルガイドが正常に削除されました`)
};

const hi_style_guide_manager_removed_toast = /** @type {(inputs: Style_Guide_Manager_Removed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्टाइल गाइड सफलतापूर्वक हटा दिया गया`)
};

const pt_pt2_style_guide_manager_removed_toast = /** @type {(inputs: Style_Guide_Manager_Removed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guia de estilo removido com sucesso`)
};

/**
* | output |
* | --- |
* | "Style guide removed successfully" |
*
* @param {Style_Guide_Manager_Removed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_removed_toast = /** @type {((inputs?: Style_Guide_Manager_Removed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Removed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_removed_toast(inputs)
	if (locale === "de") return de_style_guide_manager_removed_toast(inputs)
	if (locale === "it") return it_style_guide_manager_removed_toast(inputs)
	if (locale === "ru") return ru_style_guide_manager_removed_toast(inputs)
	if (locale === "es") return es_style_guide_manager_removed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_removed_toast(inputs)
	if (locale === "ja") return ja_style_guide_manager_removed_toast(inputs)
	if (locale === "hi") return hi_style_guide_manager_removed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_removed_toast(inputs)
	return en_style_guide_manager_removed_toast(inputs)
});